<div>

  <br/>

  <!-- Categories -->
  <div class="section-categories">
    <div class="container g-0">
      <div class="row g-0">

        <!-- Coworking -->
        <div class="col-6 col-sm-auto">
          <a routerLink="{{ coworkingPath }}">
            <span class="category" [class]="{'selected' : isCoworkingSelected}">
              <i class="category-icon bi bi-lightning-fill hide-sm"></i>
              <span class="category-title">COWORKING SEATS</span>
            </span>
          </a>
        </div>

        <!-- Conference room -->
        <div class="col-6 col-sm-auto">
          <a routerLink="{{ conferenceRoomPath }}">
            <span class="category" [class]="{'selected' : isConferenceRoomSelected}">
              <i class="category-icon bi bi-lightbulb-fill hide-sm"></i>
              <span class="category-title">CONFERENCE ROOMS</span>
            </span>
          </a>
        </div>

      </div>
    </div>
  </div>

  <br/>

  <!-- Filters -->
  <div class="section-filters">
    <div id="room-list-filter" class="accordion-collapse collapse show">
      <form>
        <div class="container g-0">
          <div class="row g-0">
            <div class="col-6 pe-2">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reserveDate" name="reserveDate" class="form-select" [(ngModel)]="reserveDate" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reserveDateOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reserveDate">Date</label>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 ps-2">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reserveTime" name="reserveTime" class="form-select" [(ngModel)]="reserveTime" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reserveTimeOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reserveTime">Time</label>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 pe-2">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reserveDuration" name="reserveDuration" class="form-select" [(ngModel)]="reserveDuration" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reserveDurationOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reserveDuration">Duration</label>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 ps-2">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reservePeople" name="reservePeople" class="form-select" [(ngModel)]="reservePeople" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reservePeopleOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reservePeople">People</label>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
